import { render } from "./HeaderNavMenu.vue?vue&type=template&id=56f4ddb6&scoped=true"
import script from "./HeaderNavMenu.vue?vue&type=script&lang=js"
export * from "./HeaderNavMenu.vue?vue&type=script&lang=js"

import "./HeaderNavMenu.vue?vue&type=style&index=0&id=56f4ddb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f4ddb6"]])

export default __exports__